module.exports = __webpack_public_path__ + "img/1768-1774.931004a2.jpg";